// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductCardDiscount_container__2RplR","wrapper":"ProductCardDiscount_wrapper__1us1w"};